import * as React from 'react';
import get from 'lodash/get';
import { getEventBusIfDefined } from '@cian/event-bus';
import { ISpecialPromoLinkData } from '../../../app/models/promo';
import { IHeaderV1Schema } from '../../repositories/header/entities/response/HeaderV1Schema';
import { IDropdownMenuContainerProps } from '../../containers/DropdownMenuContainer';
import { TopMenu, ITopMenuLinks } from '../../components/TopMenu';
import { IMenuLink, MENU_LINKS } from '../../constants/menuLinks';

export interface ITopMenuContainerProps {
  dropdownMenusData: { [key: string]: IDropdownMenuContainerProps };
  specialPromoLinkData: ISpecialPromoLinkData;
  headerData: IHeaderV1Schema;
  menuLinks: IMenuLink[];
  activeKey?: string;
}

export interface ITopMenuContainerState {
  activeKey?: string;
}

export class TopMenuContainer extends React.Component<ITopMenuContainerProps, ITopMenuContainerState> {
  public constructor(props: ITopMenuContainerProps) {
    super(props);

    this.state = {
      activeKey: this.props.activeKey,
    };
  }

  public static defaultProps = {
    menuLinks: MENU_LINKS,
  };

  public componentDidMount() {
    const eventBus = getEventBusIfDefined();

    if (eventBus) {
      eventBus.subscribe('header:category_changed', this.categoryChangedHandler);
    }
  }

  public render() {
    const { dropdownMenusData, specialPromoLinkData } = this.props;
    const { activeKey } = this.state;

    return (
      <TopMenu
        dropdownMenusData={dropdownMenusData}
        specialPromoLinkData={specialPromoLinkData}
        menuLinks={this.makeMenuLinks()}
        agenciesUrl={this.getAgenciesUrl()}
        otherLinks={this.getOtherLinks()}
        activeKey={activeKey}
      />
    );
  }

  private categoryChangedHandler = (event: CianEventBus.IEvent) => {
    const { type } = event;

    this.setState({ activeKey: type });
  };

  private makeMenuLinks = (): ITopMenuLinks[] => {
    const { menuLinks, headerData } = this.props;

    return menuLinks.map(menuLink => {
      const { name, title, trackingLabel, path, section } = menuLink;
      const link = path && get(headerData, path);

      return {
        name,
        title,
        trackingLabel,
        link,
        section,
      };
    });
  };

  private getAgenciesUrl = () => {
    const { headerData } = this.props;

    if (headerData && headerData.listingLinks?.agencies) {
      return headerData.listingLinks?.agencies;
    }

    return '';
  };

  private getOtherLinks = () => {
    const { headerData } = this.props;

    if (headerData && headerData.otherLinks) {
      return headerData.otherLinks;
    }

    return undefined;
  };
}
